import Inputc from '../../components/input.vue';
import {ajaxUtil} from '../../common/AjaxUtil.js';
import {api, msg} from '../../common/config.js';
import {MD5Util} from '../../common/MD5Util.js';
import {validateUtil} from '../../common/ValidateUtil.js';
import {replaceUtil} from '../../common/ReplaceUtil.js';
import {CommonUtil} from '../../common/CommonUtil.js';
import {store} from '../../store/store.js';
import {StorageUtil, LocalStorageUtil} from '../../common/Auth.js';
import $ from "jquery";

export default {
    name: 'forget',
    components: {
        Inputc,
    },
    data() {
        return {
            idCard: '',
            step: 1,
            code: '',//验证码
            readerData: null,
            newPassword: '',
            newPasswordAgain: '',
            message: '',
            sendPassword: {
                canClick: true,
                value: "发送验证码",
                countNumber: "",
            },
            isSend: 0,//0未发送,1发送
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            // 通过 `vm` 访问组件实例,将值传入oldUrl
            StorageUtil.storeString("historyPath", from.fullPath);
        })
    },
    beforeDestroy: function () {
        StorageUtil.removeObject("historyPath");
    },
    methods: {
        //验证身份证号
        toNext(n) {
            var _this = this;
            if (_this.idCard.trim() == "") {
                return;
            }
            var message = validateUtil.validate([{name: 'idCard'}], _this.idCard);
            if (message != null) {               
                this.$refs.a.showError(msg.idCardError);
                return;
            }
            var url = api.personal.validPhone.replace('{idCard}', _this.idCard);
            ajaxUtil.ajaxJson(url, '', 'get', (data) => { //成功
                _this.readerData = data;
                _this.sendSMS(data.phone, n);
            }, (result) => { //失败
                if (result.errorCode === 30105) {                   
                    CommonUtil.setInfo("您的证件未绑定手机号，请持证件原件到附近云图书馆平台办理!");
                } else if (result.errorCode == 30102) {
                    // this.$refs.a.showError(msg.idCardError);  
                    this.$refs.a.showError(msg.unregistered);     

                }
            }, _this);
        },
        goback() {
            history.back()
        },
        //发送短信
        sendSMS: function (phone, n) {
            var _this = this;
            var url = api.personal.sms;
            ajaxUtil.ajaxJson(url, {'phone':phone}, 'post', (data) => { //成功
                _this.isSend = 1;
                _this.step = n;
                _this.countdown(60);
                CommonUtil.setInfo(msg.sendCode);
            }, (result) => { //失败
                _this.sendPassword.canClick = true;
                CommonUtil.setInfo("操作频繁!");
            }, _this);
        },

        /**
         * 验证手机号与验证码
         * @param phone
         * @param n
         */
        resetValidPhoneCode: function (phone, n) {
            var _this = this;
            if (_this.code.trim() == "") {
                return;
            }
            if (_this.code.trim() == null || _this.code.trim().length == 0) {
                _this.$refs.b.showError(msg.codeError);
                return;
            }
            var url = api.reader.resetValidPhoneCode;
            var submitData = {
                code: _this.code,
                phone: phone,
            }
            ajaxUtil.ajaxJson(url, submitData, 'post', (data) => { //成功
                _this.step = n;
            }, (result) => { //失败
                _this.code = "";
                if (result.errorCode == 30106) {
                    CommonUtil.setInfo(msg.codeError);
                }
            }, _this);
        },

        /**
         * 重置密码
         * @param phone
         * @param n
         */
        resetPassword: function (n) {
            var _this = this;
            if (_this.newPassword.trim() == "") {
                return;
            }
            if (!_this.validatePass()) {
                return;
            }
            var url = api.reader.resetPassword;
            var submitData = {
                idCard: _this.idCard,
                newPassword: MD5Util.hex_md5(_this.newPassword),
            };
            ajaxUtil.ajaxJson(url, submitData, 'post', (data) => { //成功
                _this.step = n;
            }, (result) => { //失败
                _this.newPassword = "";
                _this.newPasswordAgain = "";
                if (result.errorCode == 30104) {
                    CommonUtil.setInfo("重置密码失败!");
                }
            }, _this);
        },
        //跳转到登陆
        login: function () {
            store.index.$refs.login.showLogin();
        },

        /**
         * 检查密码格式
         */
        validatePass: function () {
            var _this = this;
            if (_this.newPassword.length < 6 && _this.newPassword.length > 0) {
                this.$refs.c.showError(msg.passCountError);
                return false;
            } else if (_this.newPassword == null || _this.newPassword.length == 0) {
                this.$refs.c.showError(msg.emptyInputPass);
                return false;
            } else if (_this.newPasswordAgain.length < 6 && _this.newPasswordAgain.length > 0) {
                this.$refs.d.showError(msg.passCountError);
                return false;
            } else if (_this.newPasswordAgain == null || _this.newPasswordAgain.length == 0) {
                this.$refs.d.showError(msg.emptyInputPass);
                return false;
            } else if (_this.newPassword != _this.newPasswordAgain) {
                this.$refs.d.showError(msg.passDisaccord);
                return false;
            }
            return true;
        },
        //倒计时
        countdown: function (initCount) {
            if (initCount < 0) {
                return
            }
            var _this = this;
            _this.sendPassword.canClick = false;
            _this.sendPassword.value = "秒后再次发送";
            var intervalId = setInterval(function () {
                initCount--;
                if (initCount <= 0) {
                    clearInterval(intervalId);
                    _this.sendPassword.countNumber = "";
                    _this.sendPassword.canClick = true;
                    var value;
                    if (_this.isSend == 1) {
                        value = "再次发送";
                    } else {
                        value = "发送验证码";
                    }
                    _this.sendPassword.value = value;
                    return;
                } else {
                    _this.sendPassword.countNumber = initCount;
                }
            }, 1000);
        },
    }
}
